import { default as default2 } from "./components/modules/button/components/WishlistButtonContainer.js";
export {
  default2 as WishlistButton
};
//# sourceMappingURL=button.js.map
